import { useCallback, useMemo, useState } from 'react';

export type OpenClose = {
  open: () => void;
  close: () => void;
  isOpen: boolean;
  toggleOpen: () => void;
  setIsOpen(b: boolean): void;
};

export const useOpenClose = (): OpenClose => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return useMemo(() => ({ open, close, isOpen, toggleOpen, setIsOpen }), [open, close, isOpen, toggleOpen]);
};
